import React from 'react'
import _cx from 'classnames/bind'
import { Text, CheckboxField } from '@adc/ui-core'
import cls from '../../../scss/base.scss'
import ValueChangedAlert from '../valueChangedAlert'

const cx = _cx.bind(cls)

type TraditionalOfferActionFooterProps = {
  disclaimerAcknowledged: boolean
  setDisclaimerAcknowledged: (checked: boolean) => void
  isLoading: boolean
  bidAmount: number
  loadingText: string
  acknowledgeText: string
  alertText: string
}
const TraditionalOfferActionFooter = ({
  disclaimerAcknowledged,
  setDisclaimerAcknowledged,
  isLoading,
  bidAmount,
  loadingText,
  acknowledgeText,
  alertText,
}: TraditionalOfferActionFooterProps) => {
  return (
    <>
      <Text className={cx('u-mb-2')} size='tiny' color='gray'>
        <CheckboxField
          checked={disclaimerAcknowledged}
          onChange={() => setDisclaimerAcknowledged(!disclaimerAcknowledged)}
          elmId='bid_acknowledgement_checkbox'
          label={acknowledgeText}
        />
      </Text>

      {isLoading && <p className={cx('u-mb-2', 'u-mt-1')}>{loadingText}</p>}
      <ValueChangedAlert text={alertText} value={bidAmount} />
    </>
  )
}

export default TraditionalOfferActionFooter
